<template>
  <footer class="footer">
    <div class="footer_content">
      <div class="logo_wrapper">
        <div class="logo_box">
          <i class="iconfont iconziyuan1 topEdit_logo" @click="toTouEdit"></i>
          <div class="line"></div>
          <i class="iconfont iconziyuan iJournal_logo" @click="$router.push('/home')"></i>
        </div>
        <div class="web_info_box">
          <p class="text_line_height_40 text_size_12 text_color_placeholder">© 2026 Topedit All Rights Reserved</p>
          <a href="https://xyt.xcc.cn/getpcInfo?sn=1813159197290688512&language=CN&certType=8&url=www.topeditsci.com" target="_blank" style="position: relative;display: inline-block;height: 38px;">
            <div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
            <embed src="https://ithenticate.topeditsci.com/images/footer/www.topeditsci.com.svg" width="103" height="38" type="image/svg+xml" />
          </a>
        </div>
      </div>
      <div class="footer_content_item">
        <p class="footer_content_item_title">iJournal平台</p>
        <router-link to="/home" tag="p" class="footer_content_item_nav">首页</router-link>
        <router-link to="/aboutus" tag="p" class="footer_content_item_nav">关于我们</router-link>

      </div>
      <div class="footer_content_item">
        <p class="footer_content_item_title">相关服务</p>
        <a href="https://www.topeditsci.com/" target="_blank">
          <p class="footer_content_item_nav">论文服务</p>
        </a>
        <a href="https://ithenticate.topeditsci.com/" target="_blank">
          <p class="footer_content_item_nav">查重服务</p>
        </a>
      </div>
      <div class="footer_content_item">
        <p class="footer_content_item_title">战略合作伙伴</p>
        <p class="footer_content_item_nav">
          投必得学术公众号
          <img src="../../../assets/img/gongzhonghao.jpg" />
        </p>
        <a href="https://www.zhihu.com/org/tou-bi-de/" target="_blank">
          <p class="footer_content_item_nav">投必得学术知乎机构号</p>
        </a>
        <p class="footer_content_item_nav">
          智慧科研公众号
          <img src="../../../assets/img/zhihuikeyan.jpg" />
        </p>
      </div>
      <div class="footer_content_item">
        <p class="footer_content_item_title">联系我们</p>
        <p class="footer_content_item_nav">
          iJournal平台客服
          <img src="../../../assets/img/kefu.jpg" style="top: 30px;" />
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'layoutFooter',
  data () {
    return {

    }
  },
  computed: {
    // 当前年份
    currentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    // 点击投必得的LOGO进入投必得官网
    toTouEdit () {
      window.open('https://www.topeditsci.com/home', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  user-select: none;
  flex: none;
  display: flex;
  height: 250px;
  min-height: 250px;
  background-color: #202329;
  padding: 20px 0 10px 0;
  .footer_content {
    display: flex;
    height: 100%;
    width: 1180px;
    margin: 0 auto;
    .logo_wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 66px;
      .logo_box {
        display: flex;
        height: 50px;
        .topEdit_logo {
          width: 133px;
          height: 30px;
          line-height: 30px;
          font-size: 30px;
          color: #ffffff;
          margin-top: 13px;
          cursor: pointer;
        }
        .line {
          width:1px;
          height:20px;
          background:rgba(255,255,255,0.2);
          margin: 0 10px;
          margin-top: 15px;
        }
        .iJournal_logo {
          width: 95px;
          height: 30px;
          line-height: 30px;
          font-size: 30px;
          color: #ffffff;
          margin-top: 7px;
          cursor: pointer;
        }
      }
    }
    &_item {
      flex: 1;
      padding-left: 40px;
      &_title {
        color: $color-white;
        line-height: 40px;
        margin-bottom: 10px;
      }
      &_nav {
        color: #C0C4CC;
        line-height: 30px;
        position: relative;
        &:hover {
          cursor: pointer;
          color: $color-white;
          & > img {
            display: block;
          }
        }
        & > img {
          display: none;
          width: 80px;
          height: 80px;
          position: absolute;
          top: -80px;
          left: 50px;
        }
      }
    }
  }
  .ssl_wrapper {
    position: absolute;
    bottom: 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout/footer/index.vue